<template>
    <div class="patient-progress">
        <template v-if="patient.current_month > 12">
            <div class="progress-graduate">{{ __("[m] Graduate") }}</div>
            <div class="progress-weeks">&nbsp;·&nbsp;{{ patient.current_month }} {{ __("months") }}</div>
        </template>
        <template v-else>
            <template v-if="patient.current_week > 12">
                <div :class="'progress-percent week-'+patient.current_month"></div>
                <div class="progress-weeks">{{ patient.current_month }}/12 {{ __("months") }}</div>
            </template>
            <template v-else>
                <template v-if="isPatientNew">
                    <div :class="'progress-percent week-'+patient.current_week"></div>
                    <div class="progress-weeks">{{ patient.current_week }}/12 {{ __('weeks') }}</div>
                </template>
                <div v-else class="progress-weeks new">{{ __('New patient') }}</div>
            </template>
        </template>
    </div>
</template>

<script>

export default {
    props: {
        patient: {
            type: Object,
            required: true,
        }
    },
    computed: {
        isPatientNew() {
            if(moment(this.patient.programme_start) < moment().subtract(3, 'days')
            && moment(this.patient.original_programme_start) < moment().subtract(3, 'days')
            && moment(this.patient.created_at) < moment().subtract(3, 'days')) {
                return true
            }

            return false
        }
    }
}
</script>
